import { useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'

const companyNav = [
  { to: '/app/dashboard', label: 'Dashboard' },
  { to: '/app/open', label: 'Open Damages' },
  { to: '/app/in-progress', label: 'In Progress' },
  { to: '/app/closed', label: 'Closed' },
  { to: '/app/subcontractors', label: 'Subcontractors' },
  { to: '/app/search', label: 'Search' },
  { to: '/app/settings', label: 'Settings' },
  { to: '/app/help', label: 'Help' },
]

const adminNav = [
  { to: '/admin', label: 'Companies' },
  { to: '/admin/help', label: 'Help' },
]

export function AppLayout({ scope }: { scope: 'company' | 'admin' }) {
  const nav = scope === 'admin' ? adminNav : companyNav
  const { user, company, activeCompany, exitCompany, logout } = useAuth()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  // super_admin viewing a company via the switcher.
  const impersonating = scope === 'company' && user?.role === 'super_admin' && activeCompany
  const displayName = company?.name ?? (scope === 'company' ? activeCompany?.name : null) ?? 'Resilience'

  async function onLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  function backToAdmin() {
    exitCompany()
    navigate('/admin', { replace: true })
  }

  return (
    <div className="app-shell">
      <header className="topbar">
        <span className="brand">
          <img src="/logo-mark.png" alt="Resilience" className="brand-mark" />
          <span className="brand-name">
            {displayName}
            {scope === 'admin' ? ' · Admin' : ''}
          </span>
        </span>

        <nav className={menuOpen ? 'open' : undefined}>
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/admin'}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <span className="spacer" />
        {user && (
          <div className="topbar-user">
            <span className="topbar-name">{user.name}</span>
            <button className="btn-ghost" onClick={onLogout}>
              Log out
            </button>
          </div>
        )}
        <button
          className="nav-toggle"
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </header>
      {impersonating && (
        <div className="impersonation-bar">
          <span>
            Viewing <strong>{activeCompany?.name}</strong> as Resilience admin
          </span>
          <button className="link-btn" onClick={backToAdmin} style={{ color: '#fff', textDecoration: 'underline' }}>
            ← Back to admin
          </button>
        </div>
      )}
      <main className="content">
        <Outlet />
      </main>
    </div>
  )
}
